import { SignIn, SignUp } from "@clerk/react";
import { useTheme } from "../lib/theme";

const AuthLayout = ({ children }) => {
  const theme = useTheme();
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="hidden flex-col justify-between border-r border-slate-800 bg-[#131b29]/80 p-12 lg:flex">
        <img src={theme === "light" ? "/brand/ep-logo-dark.png" : "/brand/ep-logo.png"} alt="EP Group" className="h-10 w-auto self-start" />
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-sky-400">Amazon Stock Control</div>
          <h1 className="font-display mt-2 text-5xl font-bold uppercase leading-none">Stock holding,<br />days on hand &amp;<br />weekly export</h1>
          <p className="mt-4 max-w-sm text-sm text-slate-400">For EP Group staff. New accounts need an admin to give access.</p>
        </div>
        <img src={theme === "light" ? "/brand/amazon-logo.svg" : "/brand/amazon-logo-white.svg"} alt="Amazon" className="h-7 w-auto self-start" />
      </div>
      <div className="flex items-center justify-center px-4 py-10">{children}</div>
    </div>
  );
};

export const SignInPage = () => (
  <AuthLayout>
    <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
  </AuthLayout>
);

export const SignUpPage = () => (
  <AuthLayout>
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </AuthLayout>
);
